// The second strip of a grouped sales tab (D-445). Eleven sales screens sit
// under at most six tabs; the screens that share a tab (Tasks and Reviews, and
// the four configuration screens under Settings) each draw this strip under
// their header, so the reader can move between them in one press. A reader who
// may open only one screen of a group sees no strip, because that screen is a
// tab of its own.
//
// The pipeline's own strip (`PipelineTabs`) stays a strip of buttons, because
// it carries the board's filters to the list and the forecast; this one is
// links, like the area strip above it.

import { useTranslation } from "react-i18next";
import { RouterTabs } from "../../../../components/tabs";
import {
  salesNavGroupEntries,
  useSalesPermissions,
  type SalesNavGroup,
} from "../hooks/permissions";

export function SalesGroupTabs({ group }: { readonly group: Exclude<SalesNavGroup, "pipeline"> }) {
  const { t } = useTranslation();
  const perms = useSalesPermissions();
  const entries = salesNavGroupEntries(perms, group);
  if (entries.length < 2) return null;
  return (
    <RouterTabs
      label={t(`sales.nav.groupAria.${group}`)}
      className="sales-group-tabs"
      data-testid={`sales-subnav-${group}`}
      tabs={entries.map((entry) => ({
        to: entry.to,
        label: t(entry.labelKey),
        "data-testid": `sales-subtab-${entry.to.replace("/sales/", "")}`,
      }))}
    />
  );
}
